import VectorLayer from '@/models/vector-layer'
import vectorUtils from '@src/utils/vectorUtils'
import {LayerTypes} from '@models/layer'

export default class VectorLineLayer extends VectorLayer {
  constructor (obj, needMap) {
    super(obj, needMap)
    if (needMap) {
      this._type = LayerTypes.VECTOR_LINE
      this._paint = {
        'line-color': obj.color ? obj.color : vectorUtils.randomColor(),
        'line-opacity': obj.opacity ? +obj.opacity : 1,
        'line-width': obj.width ? obj.width : 3
      }
    } else {
      Object.assign(this, obj)
    }
  }

  get colorPreview () {
    if (typeof this._paint['line-color'] === 'string') return this._paint['line-color']
    return '#0cc45f'
  }

  get mapboxOpacityKeys () {
    return ['line-opacity']
  }
}



// WEBPACK FOOTER //
// ./src/models/vector-line-layer.js